import { MYQAMPUS_FEATURE_NAMES } from './feature-name-constants'
const NOTIFICATION_FEATURES_NAME = {
  CAMPUS_ATTENDANCE: MYQAMPUS_FEATURE_NAMES.STUDENTS_CAMPUS_ATTENDANCE,
  PERIOD_ATTENDANCE: MYQAMPUS_FEATURE_NAMES.STUDENTS_PERIOD_ATTENDANCE,
  SECTION_ATTENDANCE: MYQAMPUS_FEATURE_NAMES.STUDENTS_SECTION_ATTENDANCE,
  DAILY_STUDENT_ATTENDANCE: MYQAMPUS_FEATURE_NAMES.STUDENTS_DAILY_ATTENDANCE,
  FEE_MANAGER: MYQAMPUS_FEATURE_NAMES.FEE_MANAGER,
  PICKUP_PERSON: MYQAMPUS_FEATURE_NAMES.PICKUP_PERSON,
  PICKUP_MANAGER: MYQAMPUS_FEATURE_NAMES.PICKUP_MANAGER,
  SYLLABUS_AUTOMATOR: MYQAMPUS_FEATURE_NAMES.SYLLABUS_AUTOMATER,
  EXAM_PLANNER: MYQAMPUS_FEATURE_NAMES.EXAM_PLANNER,
  TIME_TABLE: MYQAMPUS_FEATURE_NAMES.TIMETABLE_MANAGER,
  SYLLABUS_MANAGER: MYQAMPUS_FEATURE_NAMES.SYLLABUS_MANAGER,
  CLASS: MYQAMPUS_FEATURE_NAMES.CLASS,
  LESSON_PLANNER: MYQAMPUS_FEATURE_NAMES.LESSON_PLANNER,
  STAFF: MYQAMPUS_FEATURE_NAMES.STAFF,
  INSTANT_NOTIFICATION: MYQAMPUS_FEATURE_NAMES.INSTANT_NOTIFICATION,
  SECTION_STUDENT: MYQAMPUS_FEATURE_NAMES.SECTION_STUDENT,
  SECTION: MYQAMPUS_FEATURE_NAMES.SECTION,
  SUPPORT_QUERY: MYQAMPUS_FEATURE_NAMES.SUPPORT_QUERY,
  SECTION_TEACHER: MYQAMPUS_FEATURE_NAMES.SECTION_TEACHER,
}
export default NOTIFICATION_FEATURES_NAME

export const NOTIFCATIONS_OPTIONS = [
  {
    id: '1',
    name: 'Concerned Student',
    value: 'concerned_student',
    receiverRoleId: 'section_student',
    concern: true,
    except: 'these concerned student',
    getUser: 'student',
  },
  {
    id: '2',
    name: 'Concerned Students',
    value: 'concerned_students',
    receiverRoleId: 'section_student',
    except: 'Concerned Students',
    concern: true,
    getUser: 'student',
  },
  {
    id: '3',
    name: 'All Students',
    value: 'all_students',
    receiverRoleId: 'section_student',
    concern: true,
    except: 'these students',
    getUser: 'student',
  },
  {
    id: '4',
    name: 'Concerned Student Main Guardian',
    value: 'concerned_student_main_guardian',
    receiverRoleId: 'guardian',
    except: 'Guardians of these Students',
    concern: true,
    getUser: 'student',
  },
  {
    id: '5',
    name: 'Concerned Students Main Guardians',
    value: 'concerned_students_main_guardians',
    receiverRoleId: 'guardian',
    except: 'Main Guardians of these Students',
    concern: true,
    getUser: 'student',
  },
  {
    id: '6',
    name: 'All Main Guardians',
    value: 'all_main_guardians',
    receiverRoleId: 'guardian',
    concern: true,
    except: 'these guardians',
    getUser: 'student',
  },
  {
    id: '7',
    name: 'Concerned student Guardians',
    value: 'concerned_student_guardians',
    receiverRoleId: 'guardian',
    except: 'Main Guardian of these Student',
    concern: true,
    getUser: 'student',
  },

  {
    id: '8',
    name: 'Concerned students Guardians',
    value: 'concerned_students_guardians',
    receiverRoleId: 'guardian',
    except: 'Guardians of these Student',
    concern: true,
    getUser: 'guardian',
  },
  {
    id: '9',
    name: 'All Guardians',
    value: 'all_guardians',
    receiverRoleId: 'guardian',
    concern: true,
    except: 'these guardians',
    getUser: 'student',
  },
  {
    id: '10',
    name: 'Specific Staff',
    receiverRoleId: 'staff',
    value: 'specific_staff',
    getUser: 'staff',
  },
  {
    id: '11',
    name: 'Concerned Teacher',
    value: 'concerned_teacher',
    receiverRoleId: 'section_teacher',
    concern: true,
    except: 'these teacher',
    getUser: 'teacher',
  },

  {
    id: '12',
    name: 'Specific Teacher',
    receiverRoleId: 'section_teacher',
    value: 'specific_teacher',
    getUser: 'teacher',
  },
  {
    id: '13',
    name: 'All Teachers',
    value: 'all_teachers',
    receiverRoleId: 'section_teacher',
    concern: true,
    except: 'these teachers',
    getUser: 'teacher',
  },
  {
    id: '14',
    name: 'Concerned Teachers',
    value: 'concerned_teachers',
    receiverRoleId: 'section_teacher',
    concern: true,
    except: 'these teacher',
    getUser: 'teacher',
  },
  {
    id: '15',
    name: 'Concerned Pickup Person',
    value: 'concerned_pickup_person',
    receiverRoleId: 'pickup_person',
    concern: true,
    except: 'these pickup person',
    getUser: 'pickup person',
  },
]

export const NOTIFICATION_RECIEVERS = {
  SPECIFIC_STAFF: 'specific_staff',
  ALL_TEACHERS: 'all_teachers',
  SPECIFIC_TEACHER: 'specific_teacher',
  CONCERNED_STUDENTS: 'concerned_students',
  CONCERNED_STUDENT: 'concerned_student',
  CONCERNED_PICKUP_PERSON: 'concerned_pickup_person',
  CONCERNED_TEACHER: 'concerned_teacher',
  CONCERNED_STUDENT_MAIN_GUARDIAN: 'concerned_student_main_guardian',
  CONCERNED_STUDENTS_MAIN_GUARDIANS: 'concerned_students_main_guardians',
  CONCERNED_STUDENTS_GUARDIANS: 'concerned_students_guardians',
  CONCERNED_STUDENT_GUARDIANS: 'concerned_student_guardians',
}

export const PUSH_NOTIFICATION_TYPES = {
  FCM: 'fcm',
  IOS_PWA_SAFARI: 'ios-pwa-safari',
}
export const COMMUNICATION_MEDIUMS = {
  WEBPUSH: 'webpush',
  SMS: 'sms',
  EMAIL: 'email',
  SOCKET: 'socket',
}
